import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
// import * as endpointSettings from '../../../../assets/config/endpoint.json';
import { Observable, of, EMPTY } from 'rxjs';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { switchMap, map, share, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public endpointSettings: {
    production: {
      payoutURL: string,
      authURL: string,
      apiGatewayURL: string,
      eddaURL: string,
      environment: string,
      proxteraURL: string,
    },
    development: {
      payoutURL: string,
      authURL: string,
      apiGatewayURL: string,
      eddaURL: string,
      environment: string,
      proxteraURL: string,
    }
  };
  constructor(public http: HttpClient) { }

  getConfigSetup(): Observable<any> {
    return this.http.get('./assets/config/endpoint.json').pipe(map((response: any) => {
      this.endpointSettings = response;
      return response;
    }));
  }

  getEndpointPayoutUrl(){
    if (environment.name == 'development'){
      return this.endpointSettings.development.payoutURL;
    } else {
      return this.endpointSettings.production.payoutURL;
    }
  }

  getEndpointAuthUrl(){
    if (environment.name == 'development'){
      return this.endpointSettings.development.authURL;
    } else {
      return this.endpointSettings.production.authURL;
    }
  }

  getEndpointApiGateway(){
    if (environment.name == 'development'){
      return this.endpointSettings.development.apiGatewayURL;
    } else {
      return this.endpointSettings.production.apiGatewayURL;
    }
  }

  getEndpointEddaApi(){
    if (environment.name == 'development'){
      return this.endpointSettings.development.eddaURL;
    } else {
      return this.endpointSettings.production.eddaURL;
    }
  }

  getEnvironment(){
    if (environment.name == 'development'){
      return this.endpointSettings.development.environment;
    } else {
      return this.endpointSettings.production.environment;
    }
  }

  isProdEnvironment(): boolean{
    const environments = {
      PROD: 'PROD',
      TEST: 'TEST',
    };
    return this.getEnvironment() === environments.PROD;
  }

  getProxteraUrl(){
    if (environment.name == 'development'){
      return this.endpointSettings.development.proxteraURL;
    } else {
      return this.endpointSettings.production.proxteraURL;
    }
  }

}
